import { render, staticRenderFns } from "./SetReturn.vue?vue&type=template&id=17742a07&"
import script from "./SetReturn.vue?vue&type=script&lang=js&"
export * from "./SetReturn.vue?vue&type=script&lang=js&"
import style0 from "./SetReturn.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports